import styled from 'styled-components'

import ActionButton from '../ActionButton'
import Popin from '../Popin'
import { Wrapper } from '../Popin/styled'

export enum Network {
  facebook = 'facebook',
  twitter = 'twitter',
}

const colors = {
  [Network.facebook]: {
    default: '#3b5998',
    active: '#2d4373',
  },
  [Network.twitter]: {
    default: '#000000',
    active: '#000000',
  },
}

export const Container = styled.div`
  position: relative;
`

export const Button = styled(ActionButton)``

export const Actions = styled.div`
  display: flex;
  gap: 1rem;
`

export const StyledPopin = styled(Popin)`
  ${Wrapper} {
    width: auto;
  }
`

export const Action = styled(ActionButton)<{ $network: Network }>`
  color: ${({ theme }) => theme.colors.pureWhite};

  border-color: ${({ $network }) => colors[$network].default};
  background-color: ${({ $network }) => colors[$network].default};

  &:hover {
    cursor: pointer;
    border-color: ${({ $network }) => colors[$network].active};
    background-color: ${({ $network }) => colors[$network].active};
  }
`
